import React, { useState } from 'react';
import { Box, Divider, Typography, Button, Tooltip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import CustomeNotificationImage from '../../../components/Insights/CustomeNotificationImage';


import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const RecommendedNotifications = ({ icon, bgColor, title, description }) => {
    const [openCustomeNotificationImage, setOpenCustomeNotificationImage] = useState(false);

    return (
        <div className="card-body my-32 mx-24  " >
            <div>
                <Box
                    sx={{
                        height: '64px',
                        width: '64px',
                        backgroundColor: bgColor,
                        borderRadius: '16px',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '8px',
                    }}
                >
                    <img src={icon} className="img-fluid" alt="icon" />
                </Box>

                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#1A1F36', lineHeight: '1', fontFamily: 'Manrope', }}>
                    {title}
                </Typography>
                <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#9095A1', height: '36px', margin: '6px auto 16px', fontFamily: 'Manrope' }}>
                    {description}
                </Typography>

                <Divider sx={{ borderColor: '#EAECF1', border: '1px solid', margin: '30px 0 16px' }} />

                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Button
                        onClick={() => setOpenCustomeNotificationImage(true)}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#FFFFFF',
                            backgroundColor: '#0076FE',
                            height: '24px',
                            padding: '0px 16px',
                            borderRadius: '100px',
                            textTransform: 'none',
                            fontFamily: 'Manrope',
                            lineHeight: ' 1',
                            '&:hover': {
                                backgroundColor: '#005fd1',
                            },
                        }}
                    >
                        + ADD
                    </Button>

                    <Box display="flex" alignItems="center" sx={{ gap: '12px' }}>
                        <Typography
                            sx={{
                                fontSize: '10px',
                                fontWeight: 400,
                                color: '#9095A1',
                                display: 'flex',
                                alignItems: 'center',
                                fontFamily: 'Manrope',
                            }}
                        >
                            <Tooltip title="Frequency of notification" arrow placement="top">
                                <AccessTimeIcon sx={{ fontSize: '16px', marginRight: '6px', fontFamily: 'Manrope' }} />
                                Hourly
                            </Tooltip>
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '10px',
                                fontWeight: 400,
                                color: '#9095A1',
                                display: 'flex',
                                alignItems: 'center',
                                fontFamily: 'Manrope',
                            }}
                        >
                            <Tooltip title="Notification platform" arrow placement="top">
                                <NotificationsActiveOutlinedIcon sx={{ fontSize: '16px', marginRight: '6px', fontFamily: 'Manrope' }} />
                                Email
                            </Tooltip>
                        </Typography>
                    </Box>
                </Box>

                <CustomeNotificationImage
                    open={openCustomeNotificationImage}
                    onClose={() => setOpenCustomeNotificationImage(false)}
                />
            </div>
        </div>
    );
};

export default RecommendedNotifications;
